import React, { useEffect, useState } from "react";
import { X } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";

// Floating WhatsApp button + auto-open teaser bubble after 6s.
export default function WhatsAppFloat() {
  const { waLink } = useSettings();
  const [showBubble, setShowBubble] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem("wa_bubble_dismissed") === "1") {
      setDismissed(true);
      return;
    }
    const t = setTimeout(() => setShowBubble(true), 6000);
    return () => clearTimeout(t);
  }, []);

  const dismiss = () => {
    setShowBubble(false);
    setDismissed(true);
    sessionStorage.setItem("wa_bubble_dismissed", "1");
  };

  const openWA = () => {
    window.open(waLink(), "_blank", "noopener,noreferrer");
    dismiss();
  };

  const WaSvg = () => (
    <svg viewBox="0 0 24 24" fill="currentColor" className="w-full h-full">
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
    </svg>
  );

  return (
    <>
      {showBubble && !dismissed && (
        <div data-testid="wa-bubble" className="fixed bottom-40 right-6 lg:bottom-24 z-40 max-w-[280px] p-4 rounded-2xl bg-[#0A0C10] border border-emerald-500/40 shadow-2xl">
          <button onClick={dismiss} className="absolute -top-2 -right-2 w-6 h-6 rounded-full bg-[#12151C] border border-white/10 flex items-center justify-center hover:bg-white/10" aria-label="Dismiss">
            <X size={12} className="text-[#A0A4AB]"/>
          </button>
          <div className="flex items-start gap-3">
            <div className="w-10 h-10 rounded-full bg-emerald-500 flex items-center justify-center flex-none text-white p-2"><WaSvg/></div>
            <div>
              <div className="font-serif text-sm text-[#EAE6DF]">Namaste 🙏</div>
              <div className="text-xs text-[#A0A4AB] mt-1 leading-relaxed">Chat directly with our team on WhatsApp — free consultation for new seekers.</div>
              <button onClick={openWA} data-testid="wa-bubble-cta" className="mt-3 w-full py-2 rounded-full bg-emerald-500 text-white text-xs font-medium hover:bg-emerald-600 transition">Start Chat</button>
            </div>
          </div>
        </div>
      )}

      <button data-testid="wa-float-btn" onClick={openWA} className="fixed bottom-36 right-6 lg:bottom-24 z-30 group" aria-label="Chat on WhatsApp">
        <span className="absolute inset-0 rounded-full bg-emerald-400/40 animate-ping"/>
        <span className="relative w-14 h-14 rounded-full bg-emerald-500 hover:bg-emerald-600 shadow-2xl flex items-center justify-center transition-colors text-white p-3.5"><WaSvg/></span>
      </button>
    </>
  );
}
